import { useMutation } from '@tanstack/react-query';
import { mediaKitsApi } from '~/api/mediaKits';

type ShareResponse = {
  id: string;
  token: string;
  entity_id: string;
  entity_type: string;
};

export const useShareMediaKit = () =>
  useMutation({
    mutationFn: (customShareableId: string) =>
      mediaKitsApi
        .post<ShareResponse>(`custom-shareable/${customShareableId}/share`, {})
        .then((res) => res.data),
  });
